module.exports = __webpack_public_path__ + "img/bn16.0be71161.png";